import { render, staticRenderFns } from "./PanchoWillies_foodItem.vue?vue&type=template&id=40573d4c&scoped=true"
import script from "./PanchoWillies_foodItem.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./PanchoWillies_foodItem.vue?vue&type=style&index=0&id=40573d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40573d4c",
  null
  
)

export default component.exports